import './index.scss';
import { useCallback, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { HiOutlineLogout } from 'react-icons/hi';
import { IMenu, MenuProps } from '../types';
import Logo from "src/assets/img/main-logo.jpg";
import { getCurrentPage } from 'src/utils/helpers';
import { AppLabel, AppText, FlexColumn, FlexRow, InfoSideBar } from "src/style";
import { MemberTypeEnum } from 'src/model';
import { useMenuList } from 'src/hooks';
import VisibilityContext from 'src/provider/state-manager/visibilityProvider';
import UserContext from 'src/provider/state-manager/userProvider';

export const SideMenu = ({ memberType, handleModal }: MenuProps) => {
    const navigate = useNavigate();
    const [selected, setSelected] = useState<string | undefined>(getCurrentPage());
    const { menu } = useMenuList();
    const { visibility, setModal } = useContext(VisibilityContext);
    const {user:{profile}} = useContext(UserContext)

    useEffect(() => {
        setSelected(getCurrentPage())
    }, [getCurrentPage()])

    const handleSelect = (item: IMenu) => {
        if (item.link === "view-results") {
            setModal({ key: "showViewResults", value: !visibility.showViewResults })
        } else if (item.link === "profile") {
          if(profile.memberType === 'Student') navigate('/dashboard/profile')
          else  setModal({key: "showUserProfileModal", value: !visibility.showUserProfileModal})
        }
        
        else if(item.link === "broadcast-mail") {
        setModal({ key: "broadCastMail", value: !visibility.broadCastMail });    
        } else if(item.link === "reset-password") {
        setModal({ key: "resetPassword", value: !visibility.resetPassword });
        } else {
            navigate(`/dashboard/${item.link}`)
        }
    }


    const renderMenu = useCallback((menu: IMenu[]) => menu?.map(item => {
        if (item.screen.includes(memberType)) {
            return (
                <FlexRow
                    gap='2'
                    width='100%'
                    bottomPadding='.8'
                    justifyContent='start'
                    leftPadding='3.5' topPadding='.8'
                    bgColor={item.link && item.link === selected ? '#702126' : ''}
                    key={item.label}
                    onClick={() => handleSelect(item)}
                    className={item.link && item.link === selected ? 'selected' : 'menu-item'}
                >
                    {item.logo}
                    <AppLabel
                        textSize='1.5'
                        bottomMargin='0'
                        fontWeight='400'
                        color={item.link && item.link === selected ? '#fff' : '#702126'}
                    >
                        {item.label !== 'User Profiles'
                            ? item.label : memberType === MemberTypeEnum.ADMIN
                                ? 'User Profiles' : memberType === MemberTypeEnum.TEACHER
                                    ? 'Student Profiles' : 'Student Profile'
                        }
                    </AppLabel>
                </FlexRow>
            )
        }
    }), [selected, memberType])

    return (
        
      <InfoSideBar className="side-menu">
       
        <FlexColumn bottomMargin="3">
          <div className="logo-container">
            <img src={Logo} alt="logo" className="menu-logo" />
          </div>
        </FlexColumn>
        {renderMenu(menu)}
        <FlexRow
          gap="2"
          width="100%"
          bottomPadding=".8"
          justifyContent="start"
          leftPadding="3.5"
          topPadding=".8"
          className={"menu-item logout"}
          onClick={handleModal}
        >
          <HiOutlineLogout size={22} />
          <AppLabel
            textSize="1.5"
            bottomMargin="0"
            fontWeight="400"
            color={"#702126"}
          >
            Logout
          </AppLabel>
        </FlexRow>
      </InfoSideBar>
    );
}